import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getPartnerEventTypeDetailAction } from "../../../store/actions/partnerEventType";
import { ViewEventType } from "../../shared/eventTypes";

const PartnerEventTypeDetail = () => {
  const dispatch = useDispatch();
  const { partnerEventTypeDetail } = useSelector( state => ( {
    partnerEventTypeDetail: state.partnerEventType.partnerEventTypeDetail,
  } ) );
  const { eventTypeId } = useParams();

  useEffect( () => {
    if( eventTypeId !== "0" ) {
      dispatch( getPartnerEventTypeDetailAction( eventTypeId ) );
    }
  }, [ eventTypeId ] );

  return <ViewEventType eventTypeDetail={partnerEventTypeDetail} type='partner'/>;
};

export default PartnerEventTypeDetail;
